import { render, staticRenderFns } from "./paymentPage.vue?vue&type=template&id=51dcb37e&scoped=true&"
import script from "./paymentPage.vue?vue&type=script&lang=js&"
export * from "./paymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcb37e",
  null
  
)

export default component.exports